/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Soyun Lee (sylee2@rsupport.com)
 *
 * @description
 *
 * @created at Thu Nov 21 2024
 **/

export type MydeskWidgetStates = {
	mydeskWidgets: WidgetSystem.WidgetBackgroundInfo;
	customBackground?: boolean;
};

export type MydeskWidgetDispatch = {
	update_mydesk_status(): void;
	initialize(): Promise<void>;
	set_customBackground_state(showState: boolean): void;
	set_background_color(color: string): void;
	set_background_DefaultImg(defaultImg: string): void;
	set_background_ImageFullPath(imagePath: string): void;
	set_background_CustomImageFile(customImageFile: File | string): void;
	set_background_CustomImageURL(customImageURL: string): void;
	delete_custom_background(): void;
	save_background(backgroundType: string, background: string | File): void;
	refresh_mydeskWidgets(): void;
};

export const InitialMydeskWidgetStates: MydeskWidgetStates = {
	mydeskWidgets: {
		background: {
			color: "",
			useCustomImage: false,
			type: "randomInitialPath"
		}
	},
	customBackground: false
};
